import IconIsReturnGoResolution from "../../../../../components/icons/icon-return-go-resolution/icon-return-go-resolution";
import IconReturnNotRefundExchange from "../../../../../components/icons/icon-return-not-refund-exchange/icon-return-not-refund-exchange";
import RmaListItemStore from "../../stores/rma-item-store";
import "./rma-resolution-name.scss";
import refundIdSrc from "../../../../../images/refundid.svg";
import reveniSrc from "../../../../../images/reveni.svg";
import riseSrc from "../../../../../images/rise.svg";
import { RMA_PROVIDERS } from "../../../../../services/api/rma-list-service";
import useDashboardTranslation from "../../../../../dashboard-translation/hooks/dashboard-translation-hook";
import { TOOLTIP_VARIANTS, Tooltip } from "../../../../../components/tooltip/tooltip";
import IconWarning from "../../../../../components/icons/icon-warning/icon-warning";
import FontBody2 from "../../../../../components/fonts/font-body2/font-body2";
import { FONT_COLOR } from "../../../../../components/fonts/font-props";
import { observer } from "mobx-react";
import { useMemo } from "react";

interface IProps {
    rma: RmaListItemStore,
}

const getProviderImage = (provider: RMA_PROVIDERS) => {
    switch (provider) {
        case RMA_PROVIDERS.REFUND_ID:
            return <img src={refundIdSrc} alt={RMA_PROVIDERS.REFUND_ID} />
        case RMA_PROVIDERS.REVENI:
            return <img src={reveniSrc} alt={RMA_PROVIDERS.REFUND_ID} />
        case RMA_PROVIDERS.RISE:
            return <img src={riseSrc} alt={RMA_PROVIDERS.RISE} />
    }
}

const RmaResolutionName: React.FC<IProps> = observer(({ rma }) => {
    const scope = 'dashboard-returns-page';
    const { getTranslation } = useDashboardTranslation();

    const noOffersIcon = useMemo(() => {
        if (!rma.noOffers) {
            return null;
        }
        if (rma.noOffers > 0) {
            const title = rma.noOffers === rma.amount ? getTranslation('NO_OFFERS_NOTE_1', scope) : getTranslation('NO_OFFERS_NOTE_2', scope);
            return (<Tooltip
                variant={TOOLTIP_VARIANTS.WARNING}
                content={<FontBody2 color={FONT_COLOR.NEUTRAL_WHITE}>
                    <div className="rma-nooffer-tooltip-content">{title}</div>
                </FontBody2>}>
                <IconWarning color="var(--color-semantic-warning)" />
            </Tooltip>);
        }
    }, [getTranslation, rma.noOffers, rma.amount]);

    const icon = useMemo(() => {
        if (rma.isRreturngoResolution) {
            return <IconIsReturnGoResolution />
        }
        if (rma.hasExchange) {
            return <IconReturnNotRefundExchange />
        }
        if (rma.refundProvider) {
            return getProviderImage(rma.refundProvider)
        }
        if (rma.creditIntegrationProvider) {
            return getProviderImage(rma.creditIntegrationProvider)
        }
        return null;
    }, [rma.refundProvider, rma.creditIntegrationProvider, rma.hasExchange, rma.isRreturngoResolution]);

    const showResloutionName = !rma.noOffers || rma.noOffers !== rma.amount;

    return (
        <div className="rma-resolution-name-container">
            {noOffersIcon}
            {icon}
            {showResloutionName && rma.resolutionName}
        </div>
    );
});

export default RmaResolutionName;
